import { render } from "./RegisterFrom.vue?vue&type=template&id=71a3bdd1&scoped=true"
import script from "./RegisterFrom.vue?vue&type=script&lang=js"
export * from "./RegisterFrom.vue?vue&type=script&lang=js"

import "./RegisterFrom.vue?vue&type=style&index=0&id=71a3bdd1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a3bdd1"]])

export default __exports__